export default __webpack_public_path__ + "static/Hans_van_Alem_2-aefe2214f0e10d8b061f020d510e5c74.jpg";